import { useEntity } from 'Context';
import { Notes } from 'Features/Notes';
import React from 'react';

export const ReferralNotes: React.FC = () => {
  const entity = useEntity();

  return <Notes id={entity.id} />;
};
